import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'dokumenPelantikan'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const masterRegion = 'Master/Region/list/'

export const undanganpelantikanCreate = 'Kepegawaian/Undanganpelantikan/create/'
export const generateDocument = 'Kepegawaian/Undanganpelantikan/generate/'
export const generateDocumentUndanganSaksi = 'Kepegawaian/Undanganpelantikan/generate_undangan_saksi/'
export const generateInvPegawai = 'Kepegawaian/Undanganpelantikan/generate_undangan_pegawaidilantik/'
export const generateInvRohaniawan = 'Kepegawaian/Undanganpelantikan/generate_permohonan_rohaniawan/'
export const generateDocumentSPMT = 'Kepegawaian/Undanganpelantikan/generate_spmt/'
export const getDocPelantikan = 'Kepegawaian/Undanganpelantikan/get_dokumen/'
export const getDocUndanganSaksi = 'Kepegawaian/Undanganpelantikan/get_dokumen/'
export const getInvPegawai = 'Kepegawaian/Undanganpelantikan/get_dokumen/'
export const getInvRohaniawan = 'Kepegawaian/Undanganpelantikan/get_dokumen/'
export const getDocSPMT = 'Kepegawaian/Undanganpelantikan/get_dokumen/'
export const undanganpelantikanList = 'Kepegawaian/Undanganpelantikan/list/'
export const undanganpelantikanDetail = 'Kepegawaian/Undanganpelantikan/detail/'
export const undanganpelantikanUpdate = 'Kepegawaian/Undanganpelantikan/update/'
export const undanganpelantikanInactive = 'Kepegawaian/Undanganpelantikan/inactive/'
export const undanganpelantikanActive = 'Kepegawaian/Undanganpelantikan/active/'
export const undanganpelantikanListPegawai = 'Kepegawaian/Undanganpelantikan/list_pegawai/'
export const undanganpelantikanListundanganpelantikan = 'Kepegawaian/Undanganpelantikan/list_undanganpelantikan/'
export const ListJabatan = 'Kepegawaian/MutasiPegawai/ListJabatan/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}